import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { modalActions } from '../../core/modal';
import { withRouter } from 'react-router';

import ModalBody from './modal-body';
import Modal from 'react-modal';
import { defaultStyles } from './modal-styles';
import Icon from 'react-icons/lib/md/content-cut';
import ProgressBar from '../common/progress-bar';
import { _Button } from '../common/styled-buttons';
import theme from '../../styles/theme';


class UploadChartModal extends React.Component {

  render() {

    const { hideModal, progress, checkoutUrl } = this.props;

    return (
      <Modal 
        isOpen={true} 
        contentLabel={"Upload Chart"} 
        onRequestClose={hideModal} 
        style={defaultStyles}
        shouldCloseOnOverlayClick={false}
        >

        <ModalBody icon={<Icon />}>
          <h2>Preparing Chart</h2>

          {checkoutUrl
            ? <_Button href={checkoutUrl} target="_blank" onClick={hideModal}>View Cart</_Button>
            : <ProgressBar progress={progress} color={theme.primary} />
          }
          
          {checkoutUrl
            ? <p>Your chart is ready! Click on the button above to preview the final image and checkout.</p>
            : <p>Nice job! One moment while we do a little behind-the-scenes magic to get your chart ready for your cart.</p>
          }
          
        </ModalBody>
      </Modal>
    )
  }
}

const mapDispatchToProps = Object.assign({}, modalActions)

export default connect(undefined, mapDispatchToProps)(UploadChartModal);


// WEBPACK FOOTER //
// ./src/components/modal/upload-chart-modal.js